<template>
  <v-dialog
    :value="open"
    @input="$emit('on-close')"
    max-width="800"
    scrollable
    transition="fade"
    :persistent="ordering"
  >
    <v-card color="white">
      
      <v-card-title class="primary white--text text-xs-center" style="position: relative;">
        <v-btn
          absolute
          small
          fab
          top
          right
          flat
          color="white"
          style="top: 10px;"
          :disabled="ordering"
          @click="$emit('on-close')"
        ><v-icon>fas fa-times</v-icon></v-btn>
        <h3 style="margin: 0 auto;">Purchase</h3>
      </v-card-title>
      <v-card-text v-if="loadingIntent || loadingCards">
        <div class="spinner">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>
      </v-card-text>
      <v-card-text v-else class="pa-0">
        <v-layout row wrap>
          <v-flex sm6 class="grey lighten-4 pa-3">
            <h3>Items Available for Purchase</h3>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex xs6
                  v-for="(item) in purchasableItems"
                  :key="'purchase-item- ' + item.id"
                >
                  <div 
                    class="pa-3"
                    style="cursor: pointer;"
                    @click="toggleSelected(item)"
                    :class="{'black white--text': isSelected(item)}"
                  >
                    <inventory-item 
                      :item="item" 
                      condensed
                      buy-now-summary
                      ignore-availability
                    ></inventory-item>  
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
            
            <table class="checkout-summary-table mt-4">
              <tr>
                <td><h3>Total</h3></td>
                <td>
                  <h3>${{ total | currency }}</h3>
                </td>
              </tr>
            </table>
          </v-flex>
          <v-flex sm6 class="pa-3">
            <v-layout row wrap>
              <v-flex v-if="cards && cards.length && !newCard" class="text-xs-center">
                Select your payment method
                <v-container fluid grid-list-md px-0>
                  <v-layout row wrap justify-center>
                    <v-flex
                      v-for="card in cards"
                      :key="card.stripe_id"
                      xs12
                    >
                      <v-hover>
                        <v-layout 
                          slot-scope="{ hover }"
                          row 
                          class="pa-2 ma-0"
                          align-center
                          :class="{'elevation-3':hover,'elevation-1':!hover,'primary white--text':(card.stripe_id == cardSelected),'grey lighten-3':(card.stripe_id != cardSelected)}"
                          style="cursor: pointer;"
                          @click="cardSelected = card.stripe_id"
                        >
                          <v-flex class="text-xs-left">
                            <i class="fab fa-cc-visa fa-3x" v-if="card.type == 'visa'" />
                            <i class="fab fa-cc-amex fa-3x" v-if="card.type == 'amex'" />
                            <i class="fab fa-cc-diners-club fa-3x" v-if="card.type == 'diners'" />
                            <i class="fab fa-cc-mastercard fa-3x" v-if="card.type == 'mastercard'" />
                            <i class="fab fa-cc-discover fa-3x" v-if="card.type == 'discover'" />
                            <i class="fab fa-cc-jcb fa-3x" v-if="card.type == 'jcb'" />
                          </v-flex>
                          <v-flex class="text-xs-right"> 
                            <div style="font-size: 1.1em;"><b>{{ card.name }}</b></div>
                            <div style="font-size: .8em;">XXXX-{{ card.last4 }}</div>
                          </v-flex>
                        </v-layout>
                      </v-hover>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
              <v-flex :class="{'d-none': (!newCard && cards && cards.length)}">
                <h3>Billing Address</h3>
                <v-container grid-list-md class="pa-0 ma-0">
                  <v-layout row wrap class="mt-3">
                    <v-flex xs12>
                      <div class="field-label">Name on Card</div>
                      <v-text-field
                        flat
                        solo
                        hide-details
                        class="pt-0"
                        v-model="billing_details.name"
                        :disabled="ordering"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <div class="field-label">Street</div>
                      <v-text-field
                        flat
                        solo
                        hide-details
                        class="pt-0"
                        v-model="billing_details.street"
                        :disabled="ordering"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <div class="field-label">City</div>
                      <v-text-field
                        flat
                        solo
                        hide-details
                        class="pt-0"
                        v-model="billing_details.city"
                        :disabled="ordering"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3>
                      <div class="field-label">State</div>
                      <v-text-field
                        flat
                        solo
                        hide-details
                        class="pt-0"
                        v-model="billing_details.state"
                        :disabled="ordering"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3>
                      <div class="field-label">Zip</div>
                      <v-text-field
                        flat
                        solo
                        hide-details
                        class="pt-0"
                        v-model="billing_details.postal"
                        :disabled="ordering"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <div class="field-label">Country</div>
                      <country-select
                        :prefill="billing_details.country"
                        @on-change="updateCountry"
                        :disabled="ordering"
                      ></country-select>
                      
                    </v-flex>
                  </v-layout>
                </v-container>
                <h3 class="mt-4">Card Information</h3>
                <v-container grid-list-md class="pa-0 ma-0">
                  <v-layout row class="mt-2">
                    <v-flex>
                      <!--<stripe
                        ref="stripe"
                        @on-change="stripeChange"
                        @on-error="processNewStripeError"
                        @on-token="processNewStripeToken"
                      ></stripe>-->
                      <stripe
                        ref="stripe"
                        :billing-details="billing_details"
                        @on-change="stripeChange"
                        @on-intent-complete="processStripeIntentComplete"
                        @on-intent-error="processStripeIntentError"
                      ></stripe>
                    </v-flex>
                  </v-layout>
                </v-container>
                
              </v-flex>
            </v-layout>
            <div class="text-xs-center">
              <v-btn color="primary" :disabled="checkoutConfirmDisabled" @click="processOrder" :loading="ordering">
                PURCHASE
              </v-btn>
            </div>
            <div class="text-xs-center mt-2" v-if="cards && cards.length && !newCard && !ordering">
              <a class="grey--text text--darken-2 caption" @click="newCard = true">ADD A CARD</a>
            </div>
            <div class="text-xs-center mt-2" v-else-if="cards && cards.length && !ordering">
              <a class="grey--text text--darken-2 caption" @click="newCard = false">CHOOSE EXISTING CARD</a>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions class="primary white--text">
        <v-spacer></v-spacer>
        
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InventoryItem from '@/components/helpers/InventoryItem';
import Stripe from '@/components/helpers/Stripe';
import CountrySelect from '@/components/helpers/CountrySelect';

export default {
  props: {
    open: Boolean,
    trip: {
      type: Object,
      require: true,
    },
    preselect: Number|String
  },
  components: {
    'inventory-item': InventoryItem,
    'stripe': Stripe,
    'country-select': CountrySelect
  },
  name: 'BuyNowDialog',
  data () {
    return {
      stripeComplete: false,
      order: {},
      ordering: false,

      selectedItems: [],
      invData: [],

      loadingIntent: false,
      intent: null,
      loadingCards: false,
      cards: null,
      cardSelected: null,
      newCard: false,


      billing_details: {
        name: this.$store.getters.user.first_name + ' ' + this.$store.getters.user.last_name,
        street: this.$store.getters.user.address_line_1,
        city: this.$store.getters.user.address_city,
        state: this.$store.getters.user.address_state,
        postal: this.$store.getters.user.address_postal,
        country: this.$store.getters.user.address_country
      }

    }
  },
  mounted: function() {
    
  },
  watch: {
    open: function(newVal, oldVal) {
      if(newVal) {
        this.loadCards();
        this.updateInventory();
        this.selectedItems = (this.preselect ? [parseInt(this.preselect.id)] : []);
      }
    }
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    user: function() {
      return this.$store.getters.user;
    },
    checkoutConfirmDisabled: function() {
      if(this.cards && this.cards.length && !this.newCard && this.cardSelected) {
        if(!this.total || this.total <= 50) return true;
        return false;
      } else {
        if(!this.billing_details.street || !this.billing_details.city || !this.billing_details.state || !this.billing_details.postal || !this.billing_details.country) return true;
        if(!this.stripeComplete) return true;
        if(!this.total || this.total <= 50) return true;

      }
      return false;
    },
    purchasableItems: function() {
      return this.invData;
    },
    selected: function() {
      let inv = [];
      for(let i = 0; i < this.invData.length; i++) {
        if(this.selectedItems.indexOf( parseInt(this.invData[i].id) ) >= 0) inv.push(this.invData[i]);
      }
      return inv;
    },
    total: function() {
      let total = 0;
      for(let i = 0; i < this.selected.length; i++) {
        let inventory = this.selected[i];
        for(let i2 = 0; i2 < inventory.variations.length; i2++) {
          let variation = inventory.variations[i2];
          if(variation.id == inventory.recommended) {
            total += parseInt(variation.tp_purchase_price);
          }
        }
      }

      return total;
    },

    /*inventory: function() {
      let arr = [];
      for(let i = 0; i < this.order.orderInventory.length; i++) {
        let inv_id = this.order.orderInventory[i].inventory_id;
        let sel_id = this.order.orderInventory[i].variation_id;
        for(let i2 = 0; i2 < this.order.inventory.length; i2++) {
          let inv = JSON.parse(JSON.stringify(this.order.inventory[i2]));
          if(this.order.inventory[i2].id == inv_id) {
            inv.recommended = sel_id;
            inv.selected = sel_id;
            arr.push(inv);
          }
        }
      }
      return arr;
    },
    selected: function() {
      let items = [];
      for(let i = 0; i < this.inventory.length; i++) {
        if(this.inventory[i].selected) items.push(this.inventory[i]);
      }
      return items;
    }*/
  },
  methods: {
    loadCards: function() {
      this.loadingCards = true;
      this.newCard = false;
      this.cardSelected = null;

      this.$http.get('users/' + this.user.id + '?fields=cards&expand=cards')
        .then(response => {
          this.cards = response.data.cards;
        })
        .catch(error => {
          //Ignore card load errors
        })
        .finally(() => {
          this.loadingCards = false;
        });
    },
    updateInventory: function() {
      let invData = [];

      let inv_map = {};
      for(let i = 0; i < this.trip.order.orderInventory.length; i++) {
        let item = this.trip.order.orderInventory[i];
        if(!item.purchaseOrder) inv_map[ item.inventory_id ] = item.variation_id;
      }

      let inv_ids = Object.keys(inv_map);
      for(let i = 0; i < this.trip.order.inventory.length; i++) {
        let inventory = this.trip.order.inventory[i];
        if(typeof inv_map[ inventory.id ] !== 'undefined') {
          inventory.recommended = inv_map[ inventory.id ];
          for(let i2 = 0; i2 < inventory.variations.length; i2++) {
            let variation = inventory.variations[i2];
            if(variation.id == inventory.recommended) {
              if(variation.tp_purchase_price >= 50) invData.push(inventory);
            }
          }
        }
      }

      this.invData = invData;
    },

    toggleSelected: function(item) {
      let ind = this.selectedItems.indexOf( parseInt(item.id) );
      if(ind >= 0 ) {
        this.selectedItems.splice(ind, 1);
      } else {
        this.selectedItems.push(parseInt(item.id));
      }
    },
    isSelected: function(item) {
      return (this.selectedItems.indexOf( parseInt(item.id) ) >= 0);
    },

    stripeChange: function(e) {
      this.stripeComplete = (e.complete ? true : false);
    },

    updateCountry: function(val) {
      this.$set(this.billing_details, 'country', val);
    },

    processOrder: function() {
      this.ordering = true;

      let orderItems = [];
      for(let ordInv of this.selected) {
        orderItems.push({inventory_id: ordInv.id, variation_id: ordInv.recommended});
      }

      let orderParams = {
        tripId: this.trip.id,
        user_id: this.user.id,
        type: 'PURCHASE',
        setInventory: orderItems
      }
      this.$http.post('orders?expand=orderInventory,inventory,inventory.variations,coupon', orderParams)
        .then(response => {
          this.order = response.data;
          
          //Get Intent
          this.$http.get('orders/' + this.order.id + '/intent')
            .then(response => {
              this.intent = response.data
              if(this.cards && this.cards.length && this.cardSelected && !this.newCard) {
                this.$refs.stripe.confirmIntent(this.intent.client_secret, this.cardSelected);
              } else {
                this.$refs.stripe.confirmIntent(this.intent.client_secret);
              }
            })
            .catch(error => {
              this.$swal.fire('Error', 'There was an error preparing your order. If this problem continues please contact support.');
            })
            .finally(() => {
              this.loadingIntent = false;
            });
          
        })
        .catch(error => {
          this.$swal.fire('Order Error', 'There was a problem creating your order. If this problem continues please contact support.');
          this.ordering = false;
        });

      
    },
    processStripeIntentComplete(e) {
      //console.log('PROCESS STRIPE INTENT COMPLETE', e);
      let status = 'PROCESSING';
      if(e === 'FREE' || e.paymentIntent.status == 'succeeded') status = 'COMPLETE';
      let params = {
        status: status
      };

      //if(this.cards && this.cards.length &&)
      this.$http.put('orders/' + this.order.id + '?expand=orderInventory,inventory,inventory.variations,coupon', params)
        .then(response => {
          //this.$emit('on-update', response.data);
        })
        .catch(error => {
          this.$swal.fire('Payment Delay', 'There is a delay in processing your payment. If you don\'t receive an order confirmation email or text in the next 5 minutes please contact support.')
        })
        .finally(() => {
          this.ordering = false;
          this.$emit('on-purchase');
        });
    },
    processStripeIntentError(e) {
      this.$swal.fire('Payment Error', e.error.message);
      this.ordering = false;
    },

    /*preProcessOrder: function() {
      this.ordering = true;

      

      let data = {
        billing_address: this.billing_street,
        billing_city: this.billing_city,
        billing_state: this.billing_state,
        billing_postal: this.billing_postal,
        billing_country: this.billing_country
      }

      this.$http.patch('users/' + this.user._id, data)
        .then(response => {
          this.processNewStripeCardOrder();
        })
        .catch(error => {
          this.$swal.fire('Error', 'There was an error updating your billing address');
          this.ordering = false;
        })
    },*/

    
    processNewStripeCardOrder: function() {
      this.$refs.stripe.getToken();
    },
    processNewStripeToken: function(token) {
      let token_id = token.id;

      if(this.user.cc_brand) {

        this.$http.post('update-card', {
          user_id: this.user._id,
          cc_source: token_id
        }).then(response => {
          this.processExistingStripeCardOrder();
        }).catch(error => {
          this.$swal.fire('Error', 'There was an error updating your card');
          this.ordering = false;
        })

        return;
      }

      let data = {
        user_id: this.user._id,
        trip_id: this.selections._id,
        lookbook_id: this.selections.lookbook._id,
        items: this.selections.lookbook.user_selected,
        total_price: this.order.total,
        total_items: this.order.total_items,
        ord_type: 'rent',
        cc_source: token_id
      }
      
      if(this.coupon) data.discount_code = this.coupon.coupon_code;

      /*this.$http.post('charge', data)
        .then(response => {
          this.checkoutDialog = false;
          this.ordering = false;

          this.$http.patch('lookbooks/' + this.selections.lookbook._id, {order_id: response.data._id})
            .then(lbResponse => {

            })
            .catch(lbError => {
              this.$swal.fire('Error', 'Your card was charged but there was an error saving your order correctly. Please contact support.');
            })
          this.$http.get('users/' + this.user._id)
            .then(usResponse => {
              this.$store.commit('setUser', usResponse.data);
            })
            .catch(usError => {});
        })
        .catch(error => {
          this.$swal.fire('Error', 'There was an error processing your order');
          this.ordering = false;
        });*/
    },
    processNewStripeError: function(msg) {
      this.$swal.fire('Credit Card Error', msg);
      this.ordering = false;
    },

    processExistingStripeCardOrder: function() {
      let data = {
        user_id: this.user._id,
        trip_id: this.selections._id,
        lookbook_id: this.selections.lookbook._id,
        items: this.selections.lookbook.user_selected,
        total_price: this.order.subtotal,
        total_items: this.selections.lookbook.user_selected.length,
        ord_type: 'rent'
      }
      if(this.coupon) data.discount_code = this.coupon.coupon_code;

      /*this.$http.post('charge', data)
        .then(response => {
          this.completedOrder = response.data;
          this.checkoutDialog = false;
          this.ordering = false;

          this.$http.patch('lookbooks/' + this.selections.lookbook._id, {order_id: response.data._id})
            .then(lbResponse => {

            })
            .catch(lbError => {
              this.$swal.fire('Error', 'Your card was charged but there was an error saving your order correctly. Please contact support.');
            });

          this.$http.get('users/' + this.user._id)
            .then(usResponse => {
              this.$store.commit('setUser', usResponse.data);
            })
            .catch(usError => {});
        })
        .catch(error => {
          this.$swal.fire('Error', 'There was an error processing your order');
          this.ordering = false;
        });*/
    },

    /*applyCoupon: function() {
      if(!this.couponCode) {
        this.$swal.fire('Invalid Coupon', 'The coupon code you have entered is invalid');
        return;
      }
      let params = {
        coupon_code: this.couponCode.toUpperCase()
      }

      this.couponLoading = true;
      this.$http.put('orders/' + this.order.id + '?expand=orderInventory,inventory,inventory.variations,coupon', params)
        .then(response => {
          this.$emit('on-update', response.data);
        })
        .catch(error => {
          this.$swal.fire('Invalid Coupon', 'The coupon code you have entered is invalid');
        })
        .finally( () => {
          this.couponLoading = false;
        })
    },

    removeCoupon: function() {
      let params = {
        coupon_code: null
      };

      this.couponLoading = true;
      this.$http.put('orders/' + this.order.id + '?expand=orderInventory,inventory,inventory.variations,coupon', params)
        .then(response => {
          this.couponCode = null;
          this.$emit('on-update', response.data);
        })
        .catch(error => {
          this.$swal.fire('Error', 'There was a problem removing the coupon. Please try again.');
        })
        .finally( () => {
          this.couponLoading = false;
        });

    },*/

    /*openCheckout: function() {
      
      //PROCESS FREE DIFFERENTLY
      if(this.order.total < 50) {
        this.processStripeIntentComplete('FREE');
        return;
      }

      this.loadingIntent = true;
      this.loadingCards = true;
      this.newCard = false;
      this.cardSelected = null;

      this.checkoutDialog = true;
      this.$http.get('orders/' + this.order.id + '/intent')
        .then(response => {
          this.intent = response.data
        })
        .catch(error => {
          this.$swal.fire('Error', 'There was an error preparing your order. If this problem continues please contact support.');
          this.checkoutDialog = false;
        })
        .finally(() => {
          this.loadingIntent = false;
        })
      this.$http.get('users/' + this.user.id + '?fields=cards&expand=cards')
        .then(response => {
          this.cards = response.data.cards;
        })
        .catch(error => {
          //Ignore card load errors
        })
        .finally(() => {
          this.loadingCards = false;
        });
    }*/
    
  }
}
</script>